import React, { useEffect, useState } from "react";
import welcome_dashboard from "../../../assets/img/welcome-dashboard.svg";
import { Col, Row } from "react-bootstrap";
import review from "../../../assets/img/review.svg";
import first_promotion from "../../../assets/img/first-promotion.svg";
import contract_template_icon from "../../../assets/img/approved the contract.svg";
import business_verification_icon from "../../../assets/img/Business Verification icon.svg";
import contractor_license_icon from "../../../assets/img/Contractors License Verification icon.svg";
import browse_job from "../../../assets/img/browse-job.svg";
import browse_bid from "../../../assets/img/browse-bid.svg";
import browse_reviews from "../../../assets/img/browse-reviews.svg";
import { Link } from "react-router-dom";
import search_dash from "../../../assets/img/search_dash.svg";
import add_dash from "../../../assets/img/add_dash.svg";
import support_dash from "../../../assets/img/support_dash.svg";
import post_promotion from "../../../assets/img/post_promotion_dash.svg";
import total_bid from "../../../assets/img/total_bid.svg";
import activity_yet from "../../../assets/img/activity_yet.svg";
import recent_activity_bid from "../../../assets/img/recent_activity_bid.svg";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import Loader from "../../Loader/Loader";
import { useNavigate } from "react-router-dom";
import { hitGetDashboardApi } from "../../../Redux/Professional/DashboardSlice";
import { hitGetBidListingProfessionalApi } from "../../../Redux/Professional/BidListingProfessionalSlice";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import EarnedAmount from "../../../assets/img/Earned amount.svg";
import Reviews from "../../../assets/img/Reviews dashboard.svg";
import { hitUpdateProfileProfessionalApi } from "../../../Redux/Professional/UpdateProfileProfessionalSlice";
import CompletedJobs from "../../../assets/img/Completed Jobs.svg";
import { Modal } from "react-bootstrap";
import { timeAgo } from "../../../Helper/CommonFunctions";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";
import { FaMapMarkerAlt, FaClock, FaStar } from "react-icons/fa";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import External from "../../../assets/svg/External";
import profile_icon from "../../../assets/img/profileIcon.png";
import { hitGetStartVerificationVeriff } from "../../../Redux/Common/CreateVeriffVerificationSlice";

function formatMyBidAmount(bid) {
  const tryNum = (v) => {
    if (v == null || v === "") return null;
    const n = typeof v === "number" ? v : parseFloat(String(v).replace(/[^0-9.-]/g, ""));
    return Number.isNaN(n) ? null : n;
  };
  const keys = ["totalAmount", "bidTotal", "grandTotal", "totalPrice", "finalAmount", "amount"];
  for (const k of keys) {
    const n = tryNum(bid?.[k]);
    if (n != null) {
      return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  }
  if (Array.isArray(bid?.options)) {
    let sum = 0;
    bid.options.forEach((o) => {
      const p = tryNum(o.optionPrice);
      if (p != null) sum += p;
    });
    if (sum > 0) {
      return `$${sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  }
  const b = tryNum(bid?.jobId?.budget);
  if (b != null) {
    return `$${b.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return "—";
}

function getMyBidStatusMeta(bid) {
  const s = bid?.status;
  if (s === "awarded" || s === 2) return { label: "Awarded", className: "awarded" };
  if (s === 3) return { label: "Completed", className: "completed" };
  if (s === 5 || bid?.isDraft === 1) return { label: "Draft", className: "draft" };
  return { label: "Bid placed", className: "placed" };
}

const Dashboard = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [professionalProfile, setProfessionalProfile] = useState(null);
  const [isContractTemplateDone, setIsContractTemplateDone] = useState(false);
  const [needToShowCoachmarkers, setNeedToShowCoachmarkers] = useState(0);
  const [promotions, setPromotions] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);

  const [recentActivities, setRecentActivities] = useState([]);
  const [earnedAmount, setEarnedAmount] = useState(0);
  const [totalBids, setTotalBids] = useState(0);
  const [completedJobs, setCompletedJobs] = useState(0);
  const [reviewsCount, setReviewsCount] = useState(0);
  const [totalCreditPoints, setTotalCreditPoints] = useState(0);
  const [totalPotentialEarnings, setTotalPotentialEarnings] = useState(0);
  const [jobCount, setJobCount] = useState(0);
  const [settings, setSettings] = useState({});
  const [subscriptionPlan, setSubscriptionPlan] = useState("");
  const [isFirstBidSubmitted, setIsFirstBidSubmitted] = useState(0);
  const [totalPromotions, setTotalPromotions] = useState(0);
  const [isBusinessVerified, setIsBusinessVerified] = useState(false);
  const [isImportReviewsDone, setIsImportReviewsDone] = useState(false);
  const [totalCompletedJobs, setTotalCompletedJobs] = useState(false);
  const [isFirstContractorReferred, setIsFirstContractorReferred] = useState(0);
  const [isContractLicensesVerified, setIsContractLicensesVerified] = useState(false);
  const [isFirstJobViewed, setIsFirstJobViewed] = useState(0);
  const [myBids, setMyBids] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      setGlobalLoading(true);
      fetchDashboardData();
      dispatch(hitGetSettingsApi()).then((response) => {
        if (response.payload.status === true) {
          setSettings(response.payload.data);
        } else {
          showToast("Failed to fetch settings", "error");
        }
      });
    }
  }, []);

  useEffect(() => {
    const handleWindowFocus = () => {
      if (localStorage.getItem("professionalToken")) {
        fetchDashboardData();
      }
    };

    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        localStorage.getItem("professionalToken")
      ) {
        fetchDashboardData();
      }
    };

    window.addEventListener("focus", handleWindowFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const fetchDashboardData = async () => {
    const response = await dispatch(hitGetDashboardApi());
    if (response.payload.status === true) {
      setLoading(false);
      setGlobalLoading(false);
      setNeedToShowCoachmarkers(
        response.payload.data.profile.needToShowCoachmarkers || 0
      );
      setDashboardData(response.payload.data);
      setProfessionalProfile(response.payload.data.profile || null);
      setSubscriptionPlan(response.payload.data.profile.subscriptionPlan || "");
      setPromotions(response.payload.data.promotions || []);
      setRecentActivities(response.payload.data.recentActivities || []);
      setEarnedAmount(response.payload.data.profile.totalEarnedAmount || 0);
      setTotalCreditPoints(response.payload.data.profile.totalCreditPoints || 0);
      setTotalBids(response.payload.data.profile.totalBids || 0);
      setTotalCompletedJobs(response.payload.data.profile.totalCompletedJobs > 0 ? true : false);
      setIsFirstContractorReferred(response.payload.data.profile.isFirstContractorReferred || 0);
      setIsImportReviewsDone(response.payload.data.profile.isImportReviewsDone === 1 ? true : false);
      setIsBusinessVerified(response.payload.data.profile.isBusinessVerified || 0);
      setIsContractLicensesVerified(response.payload.data.profile.isContractorLicenseVerified || 0);
      const profile = response.payload.data.profile;
      setIsContractTemplateDone(
        Boolean(profile.businessAddress?.trim() && profile.termsAndConditions?.trim())
      );
      setIsFirstBidSubmitted(response.payload.data.profile.isFirstBidSubmitted || 0);
      setTotalPromotions(response.payload.data.profile.totalPromotions || 0);
      setCompletedJobs(response.payload.data.profile.totalCompletedJobs || 0);
      setReviewsCount(response.payload.data.profile.totalReviews || 0);
      setJobCount(response.payload.data.profile.totalJobs || 0);
      setIsFirstJobViewed(response.payload.data.profile.isFirstJobViewed || 0);
      let potentialEarnings = 0;
      const settings = response.payload.data.settings;

      //console.log("isBusinessVerified", isBusinessVerified);
      //console.log("totalBids", totalBids);
      //console.log("totalPromotions", totalPromotions);
      //console.log("isContractLicensesVerified", isContractLicensesVerified);
      //console.log("isImportReviewsDone", isImportReviewsDone);
      //console.log("totalCompletedJobs", totalCompletedJobs);
      //console.log("isFirstContractorReferred", isFirstContractorReferred);

      if (isBusinessVerified === 0) {

        potentialEarnings += settings.professionalVerifyBusinessPoints || 0;
      }
      if (totalBids === 0) {
        potentialEarnings += settings.professionalSubmitFirstBidPoints || 0;
      }
      if (totalPromotions === 0) {
        potentialEarnings += settings.professionalPostFirstPromotionPoints || 0;
      }
      if (isContractLicensesVerified === 0) {
        potentialEarnings += settings.professionalVerifyLicensePoints || 0;
      }
      if (isImportReviewsDone === false) {
        potentialEarnings += settings.professionalImportReviewsPoints || 0;
      }
      if (totalCompletedJobs === false) {
        potentialEarnings += settings.professionalCompleteFirstJobPoints || 0;
      }
      // if (isFirstContractorReferred === 0) {
      //   potentialEarnings += settings.refererFirstContractor || 0;
      // }
      setTotalPotentialEarnings(potentialEarnings);

      try {
        const [a1, a2] = await Promise.all([
          dispatch(hitGetBidListingProfessionalApi({ type: 1 })),
          dispatch(hitGetBidListingProfessionalApi({ type: 2 })),
        ]);
        const map = new Map();
        [a1.payload, a2.payload].forEach((p) => {
          if (p?.status === true && Array.isArray(p.data)) {
            p.data.forEach((b) => {
              if (b?._id && !map.has(b._id)) map.set(b._id, b);
            });
          }
        });
        const merged = Array.from(map.values()).sort((x, y) => {
          const tx = new Date(x.updatedAt || x.createdAt || 0).getTime();
          const ty = new Date(y.updatedAt || y.createdAt || 0).getTime();
          return ty - tx;
        });
        setMyBids(merged.slice(0, 4));
      } catch {
        setMyBids([]);
      }
    } else {
      setGlobalLoading(false);
      setLoading(false);
      setMyBids([]);
      showToast("Failed to fetch data", "error");
    }
  };

  const [openWel, setOpenWel] = useState(false);
  const [step, setStep] = useState(1);

  const total = 6;

  const handleNext = () => {
    if (step < total) {
      setStep(step + 1);
    } else {
      dispatch(hitUpdateProfileProfessionalApi({ needToShowCoachmarkers: 0 }));
      setNeedToShowCoachmarkers(0);
    }
  };

  const handlePrevious = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSkip = () => {
    dispatch(hitUpdateProfileProfessionalApi({ needToShowCoachmarkers: 0 }));
    setNeedToShowCoachmarkers(0);
  };


  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const profileSteps = Number(professionalProfile?.profileSteps ?? 4);
  const idVerificationStatus = Number(
    professionalProfile?.idVerificationStatus ?? 2
  );
  const isIdVerificationPending = idVerificationStatus === 1;
  const isIdVerificationRejected = idVerificationStatus === 3;
  const idVerificationTitle = isIdVerificationPending
    ? "Verification Submitted"
    : isIdVerificationRejected
      ? "Verification Failed"
      : "Verify Your Identity";
  const idVerificationDescription = isIdVerificationPending
    ? "Your verification documents have been submitted successfully and are pending admin review."
    : isIdVerificationRejected
      ? "Your last verification attempt was not approved. Please resubmit your documents to try again."
      : "Complete secure ID verification with our trusted partner.";
  const idVerificationButtonLabel = isIdVerificationPending
    ? "Pending Review"
    : isIdVerificationRejected
      ? "Retry Verification"
      : "Start Verification";
  const displayName =
    professionalProfile?.companyName ||
    professionalProfile?.firstName ||
    "Professional";
  const profileImageSrc =
    (professionalProfile?.profileImage &&
      String(professionalProfile.profileImage).trim()) ||
    (professionalProfile?.companyLogo &&
      String(professionalProfile.companyLogo).trim()) ||
    profile_icon;

  const goCompleteProfile = () => {
    if (profileSteps === 0) navigation("/professional/signup-one");
    else if (profileSteps === 1) navigation("/professional/signup-two");
    else if (profileSteps === 2) navigation("/professional/signup-three");
    else if (profileSteps === 3) navigation("/professional/signup-four");
    else navigation("/professional/edit-profile");
  };

  const startIdVerification = async () => {
    const firstName = professionalProfile?.firstName?.trim();
    const lastName = professionalProfile?.lastName?.trim();
    if (!firstName || !lastName) {
      showToast(
        "Please complete your profile with first and last name before verifying",
        "error"
      );
      goCompleteProfile();
      return;
    }
    const response = await dispatch(
      hitGetStartVerificationVeriff({
        firstName,
        lastName,
        type: 1,
      })
    );
    if (response.payload?.status === "success") {
      window.open(response.payload.verification.url, "_blank");
    } else {
      showToast("Failed to start verification. Please try again.", "error");
    }
  };

  const quickStats = [
    {
      id: "bids",
      title: "Total Bids",
      value: totalBids,
      subtitle: "Total bids on projects",
      icon: total_bid,
    },
    {
      id: "jobs",
      title: "Completed Jobs",
      value: completedJobs,
      subtitle: "Total completed jobs",
      icon: CompletedJobs,
    },
    {
      id: "reviews",
      title: "Reviews",
      value: reviewsCount,
      subtitle: "Total reviews received",
      icon: Reviews,
    },
    {
      id: "credits",
      title: "Credits",
      value: totalCreditPoints,
      subtitle: "Total credits",
      icon: EarnedAmount,
    },
  ];

  const quickActions = [
    {
      id: "find-jobs",
      title: "Find New Jobs",
      description: "Browse available renovation projects",
      icon: search_dash,
      className: "pro-quick-action--find",
      onClick: () => navigation("/professional/jobs"),
    },
    {
      id: "submit-bid",
      title: "Submit New Bid",
      description: "Place a bid on renovation projects",
      icon: add_dash,
      className: "pro-quick-action--bid",
      onClick: () => navigation("/professional/jobs"),
    },
    {
      id: "support",
      title: "Contact Support",
      description: "Get help from our support team",
      icon: support_dash,
      className: "pro-quick-action--support",
      onClick: () => {},
    },
    {
      id: "promotion",
      title: "Post Promotion",
      description: "Share special offers with Homeowners.",
      icon: post_promotion,
      className: "pro-quick-action--promotion",
      onClick: () => navigation("/professional/add-campaign"),
    },
  ];

  const welcomeTasks = [
    {
      id: "contract-template",
      show: !isContractTemplateDone,
      icon: contract_template_icon,
      iconAlt: "contract-template",
      title: "Create Your Contract Template",
      description:
        "Create your contract settings template that your clients will see",
      onClick: () =>
        navigation("/professional/settings", { state: { type: "contract" } }),
    },
    {
      id: "verify-business",
      show: isBusinessVerified === 0,
      icon: business_verification_icon,
      iconAlt: "verify-business",
      title: "Verify your Business",
      description: "Complete business verification process",
      onClick: () => navigation("/professional/edit-profile"),
    },
    {
      id: "first-promotion",
      show: totalPromotions === 0,
      icon: first_promotion,
      iconAlt: "first-promotion",
      title: "Post Your First Promotion",
      description: "Create a promotional campaign to attract customers",
      onClick: () => navigation("/professional/campaigns"),
    },
    {
      id: "verify-license",
      show: isContractLicensesVerified === 0,
      icon: contractor_license_icon,
      iconAlt: "verify-contractor-license",
      title: "Verify Your Contractors License",
      description: "Upload your contractors license for verification",
      onClick: () => navigation("/professional/edit-profile"),
    },
    {
      id: "import-reviews",
      show: isImportReviewsDone === false,
      icon: review,
      iconAlt: "import-reviews",
      title: "Import Reviews",
      description:
        "Boost credibility with existing reviews from external platforms",
      onClick: () => navigation("/professional/import-reviews"),
    },
  ].filter((task) => task.show);

  if (loading) {
    setGlobalLoading(true);
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <>
      <div className="pro-app-page pro-app-page--muted">
        <div className="custom_container pro-dashboard-inner">
          <h1 className="pro-dashboard-title">Dashboard</h1>

          {profileSteps !== 4 && (
            <section className="pro-dashboard-card pro-manage-profile-card">
              <Person2OutlinedIcon className="pro-manage-profile-card__icon" />
              <h2>Manage your profile</h2>
              <p>
                You need to complete your profile first to bid on Renovations
                projects.
              </p>
              <button
                type="button"
                className="pro-btn pro-btn--primary"
                onClick={goCompleteProfile}
              >
                Complete Your Profile
              </button>
            </section>
          )}

          {idVerificationStatus !== 2 && (
            <section className="pro-dashboard-section">
              <h2 className="pro-section-label">
                ID Verification <span className="pro-required">*</span>
              </h2>
              <div className="pro-dashboard-card pro-id-verify-card">
                <Person2OutlinedIcon className="pro-id-verify-card__icon" />
                <h3>{idVerificationTitle}</h3>
                <p>{idVerificationDescription}</p>
                <button
                  type="button"
                  className="pro-btn pro-btn--blue pro-id-verify-btn"
                  onClick={startIdVerification}
                  disabled={isIdVerificationPending}
                >
                  {!isIdVerificationPending && <External />}
                  {idVerificationButtonLabel}
                </button>
              </div>
            </section>
          )}

          <div className="task-progress-container">
              <header className="task-header">
                <img src={welcome_dashboard} alt="Welcome" />
                <h2>Welcome to SimpleRenovate!</h2>
                <p>
                  You&apos;re just a few steps away from connecting with Clients
                  and growing your renovation business.
                </p>
              </header>
              {welcomeTasks.length > 0 && (
                <div className="dashboard-welcome-tasks">
                  {welcomeTasks.map((task) => (
                    <div className="task-list dashboard-welcome-task" key={task.id}>
                      <div className="task">
                        <div
                          className="card_task_img_content"
                          onClick={task.onClick}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              task.onClick();
                            }
                          }}
                        >
                          <div className="task-icon-wrap">
                            <img src={task.icon} alt={task.iconAlt} />
                          </div>
                          <div>
                            <div className="task-name">{task.title}</div>
                            <span>{task.description}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

          <section className="pro-dashboard-section">
            <div className="pro-stats-grid">
              {quickStats.map((stat) => (
                <div className="pro-stat-card" key={stat.id}>
                  <div className="pro-stat-card__head">
                    <span className="pro-stat-card__title">{stat.title}</span>
                    <img src={stat.icon} alt="" className="pro-stat-card__icon" />
                  </div>
                  <div className="pro-stat-card__value">{stat.value}</div>
                  <div className="pro-stat-card__subtitle">{stat.subtitle}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="pro-dashboard-card pro-profile-overview">
            <img
              src={profileImageSrc}
              alt={displayName}
              className="pro-profile-overview__avatar"
              onError={(e) => {
                e.currentTarget.src = profile_icon;
              }}
            />
            <h3 className="pro-profile-overview__name">{displayName}</h3>
            <div className="pro-profile-overview__reviews">
              <div className="pro-profile-overview__stars">
                {[1, 2, 3, 4, 5].map((i) => (
                  <FaStar key={i} aria-hidden />
                ))}
              </div>
              <p className="pro-profile-overview__reviews-text">No reviews yet</p>
              <button
                type="button"
                className="pro-profile-overview__link"
                onClick={() => navigation("/professional/import-reviews")}
              >
                Import your first reviews
              </button>
            </div>
          </section>

          {!totalCompletedJobs && (
            <section className="pro-dashboard-card pro-performance-card">
              <h3>Build Your Performance Profile</h3>
              <p>
                Complete jobs and receive reviews to unlock your performance
                metrics
              </p>
              <button type="button" className="pro-performance-card__unlock">
                Complete your first job to unlock
              </button>
            </section>
          )}

          <section className="pro-dashboard-section pro-quick-actions-section">
            <h2 className="pro-section-heading">Quick Actions</h2>
            <div className="pro-quick-actions-panel">
              {quickActions.map((action) => (
                <div
                  key={action.id}
                  className={`pro-quick-action ${action.className}`}
                  onClick={action.onClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      action.onClick();
                    }
                  }}
                >
                  <div className="pro-quick-action__icon-wrap">
                    <img src={action.icon} alt="" />
                  </div>
                  <div>
                    <div className="pro-quick-action__title">{action.title}</div>
                    <span>{action.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {promotions.length > 0 && (
            <section className="promotion_sec pro-dashboard-section">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h2 className="pro-section-heading mb-0">Promotions</h2>
                <Link to="/professional/campaigns" className="pro-link-see-all">
                  View All +
                </Link>
              </div>
              <Row>
                {promotions.map((promotion, index) => (
                  <Col md={6} key={index}>
                    <div className="task-list">
                      <div className="task">
                        <div className="card_task_img_content">
                          <div className="task-name">{promotion.promotionTitle}</div>
                          <div
                            className={`task-credits ${
                              promotion.status === 1 ? "active" : "inactive"
                            }`}
                          >
                            {promotion.status === 1 ? "Active" : "Paused"}
                          </div>
                        </div>
                        <span>{promotion.promotionDetails}</span>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </section>
          )}

          {myBids.length > 0 && (
            <section className="my-bids-section pro-dashboard-section">
              <div className="my-bids-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h2 className="pro-section-heading mb-0">My Bids</h2>
                <Link to="/professional/bids" className="my-bids-see-all">
                  See All
                </Link>
              </div>
              {myBids.map((bid) => {
                const job = bid?.jobId || {};
                const thumb =
                  job.media && job.media.length > 0
                    ? job.media[0]
                    : "https://via.placeholder.com/112x112?text=Job";
                const statusMeta = getMyBidStatusMeta(bid);
                const when = bid.updatedAt || bid.createdAt;
                return (
                  <div
                    key={bid._id}
                    className="my-bids-card"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      navigation(`/professional/job-details/${job._id}`)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigation(`/professional/job-details/${job._id}`);
                      }
                    }}
                  >
                    <div className="my-bids-thumb">
                      <img src={thumb} alt={job.title || "Job"} />
                    </div>
                    <div className="my-bids-center">
                      <div className="my-bids-title">{job.title || "Project"}</div>
                      <div className="my-bids-loc">
                        <FaMapMarkerAlt aria-hidden className="my-bids-loc-icon" />
                        <span>
                          {[job.city, job.state].filter(Boolean).join(", ") ||
                            "Location TBD"}
                        </span>
                      </div>
                      <div className="my-bids-price">{formatMyBidAmount(bid)}</div>
                    </div>
                    <div className="my-bids-aside">
                      <span
                        className={`my-bids-badge my-bids-badge--${statusMeta.className}`}
                      >
                        {statusMeta.label}
                      </span>
                      <div className="my-bids-time">
                        <FaClock aria-hidden className="my-bids-time-icon" />
                        <span>{when ? timeAgo(when) : "—"}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </section>
          )}

          {recentActivities.length > 0 ? (
            <section className="pro-dashboard-section recent_activity">
              <div className="pro-dashboard-card">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h2 className="pro-section-heading mb-0">Recent Activities</h2>
                  <Link to="#" className="pro-link-see-all">
                    View All
                  </Link>
                </div>
                {recentActivities.map((activity, index) => (
                  <div className="task_2" key={index}>
                    <img src={recent_activity_bid} alt="recent activity" />
                    <div>
                      <div className="task-name">{activity.activityTitle}</div>
                      <span>{activity.activityDescription}</span>
                      <span className="span_1">{timeAgo(activity.createdAt)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ) : (
            <section className="pro-empty-state-card pro-empty-state-card--activity">
              <div className="pro-empty-state-card__icon-wrap">
                <img src={activity_yet} alt="" />
              </div>
              <h3>No Activity Yet</h3>
              <p>
                Your recent activity will appear here once you start bidding on
                projects and completing jobs.
              </p>
            </section>
          )}

          {isFirstJobViewed === 0 && (
            <section className="pro-empty-state-card pro-empty-state-card--jobs">
              <div className="pro-empty-state-card__icon-wrap pro-empty-state-card__icon-wrap--blue">
                <img src={browse_job} alt="" />
              </div>
              <h3>No Jobs Yet</h3>
              <p>
                Start bidding on projects &amp; your active projects will show
                here. Here you will see all the jobs you&apos;re currently
                working on.
              </p>
              <button
                type="button"
                className="pro-btn pro-btn--blue pro-btn--block"
                onClick={() => {
                  handleViewDetails();
                  navigation("/professional/jobs");
                }}
              >
                Browse Available Jobs
              </button>
            </section>
          )}

          {isFirstBidSubmitted === 0 && (
            <section className="pro-empty-state-card pro-empty-state-card--bids">
              <div className="pro-empty-state-card__icon-wrap pro-empty-state-card__icon-wrap--green">
                <img src={browse_bid} alt="" />
              </div>
              <h3>No Bid Submitted</h3>
              <p>
                Submit your first bid on a renovation project. Create compelling
                proposals to win more jobs and grow your business.
              </p>
              <button
                type="button"
                className="pro-btn pro-btn--green pro-btn--block"
                onClick={() => {
                  handleViewDetails();
                  navigation("/professional/jobs");
                }}
              >
                Create Your First Bid
              </button>
            </section>
          )}

          {promotions.length === 0 && (
            <section className="pro-empty-state-card pro-empty-state-card--promotions">
              <div className="pro-empty-state-card__icon-wrap pro-empty-state-card__icon-wrap--pink">
                <img src={first_promotion} alt="" />
              </div>
              <h3>No Promotions Yet</h3>
              <p>
                Create your first promotion to showcase special offers and
                attract more clients to your services.
              </p>
              <button
                type="button"
                className="pro-btn pro-btn--brand pro-btn--block"
                onClick={() => navigation("/professional/add-campaign")}
              >
                Create Promotion
              </button>
            </section>
          )}

          {reviewsCount === 0 && (
            <section className="pro-empty-state-card pro-empty-state-card--reviews">
              <div className="pro-empty-state-card__icon-wrap pro-empty-state-card__icon-wrap--purple">
                <img src={browse_reviews} alt="" />
              </div>
              <h3>No Reviews Yet</h3>
              <p>
                Complete your first job to start earning reviews from satisfied
                customers. Great reviews help you win more projects!
              </p>
              <button
                type="button"
                className="pro-btn pro-btn--purple pro-btn--block"
                onClick={() => {
                  handleViewDetails();
                  navigation("/professional/import-reviews");
                }}
              >
                Import Reviews
              </button>
            </section>
          )}
        </div>

        {needToShowCoachmarkers === 1 && (
          <Modal show={true} className="modal_welcome">
            <Modal.Body>
              <div className={`tour-step ${isFlipped ? "flip" : ""}`}>
                <div className="tour-header">
                  <div className="step-count">
                    <div className="icon">💡</div>
                    <span>{` ${step} of ${total}`}</span>
                  </div>
                  <button className="close-btn" onClick={handleSkip}>
                    ✕
                  </button>
                </div>
                {step === 1 && (
                  <div className="tour-content">
                    <h2>Welcome to SimpleRenovate!</h2>
                    <p>
                      Let's take a quick tour to help you get started. This is
                      your business profile - the heart of your dashboard.
                    </p>
                  </div>
                )}
                {step === 2 && (
                  <div className="tour-content">
                    <h2>Quick Actions</h2>
                    <p>
                      Use these shortcuts to quickly find jobs, upgrade your
                      account, or get help.
                    </p>
                  </div>
                )}
                {step === 3 && (
                  <div className="tour-content">
                    <h2>Available Jobs</h2>
                    <p>
                      Browse and bid on renovation projects that match your
                      skills. Click "Browse Available Jobs" to see more.
                    </p>
                  </div>
                )}{" "}
                {step === 4 && (
                  <div className="tour-content">
                    <h2>Build Your Reputation</h2>
                    <p>
                      Reviews are crucial for winning more projects. Import
                      existing reviews or learn how to earn new ones.
                    </p>
                  </div>
                )}{" "}
                {step === 5 && (
                  <div className="tour-content">
                    <h2>Navigation</h2>
                    <p>
                      Use the top bar to access Jobs, Messages, and Promotions.
                      Tap the menu icon (☰) for more.
                    </p>
                  </div>
                )}
                <div className="tour-progress">
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${(step / total) * 100}%` }}
                    ></div>
                  </div>
                </div>
                <div className="tour-footer">
                  <button
                    className="previous-btn"
                    onClick={handlePrevious}
                    disabled={step === 1}
                  >
                    ← Previous
                  </button>
                  <button className="skip-btn" onClick={handleSkip}>
                    Skip tour
                  </button>
                  <button className="next-btn" onClick={handleNext}>
                    Next →
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default Dashboard;
